import { memo } from 'react'

import type { AcfTrustpilotIntroProps } from '@typings'
import {
  RaContainer,
  RaGridItem,
  RaHeading,
  RaIllustration,
  RaRichText,
} from '@components/core/index.core'

// Mirrors the columns/content block the live site uses for this section: a
// full-width RaGridItem (which carries the surrounding 16px block margins) with
// the same illustration/heading/rich-text stack. The illustration index is
// fixed to 2 (single-diamond ornament) to match the live design regardless of
// the section's page position.
export const AcfTrustpilotIntro = memo((props: AcfTrustpilotIntroProps) => {
  return (
    <RaContainer>
      <RaGridItem
        xs={12}
        md={12}
        lg={12}>
        <RaIllustration index={2} />
        {props.title && <RaHeading component="h2">{props.title}</RaHeading>}
        {props.content && <RaRichText content={props.content} />}
      </RaGridItem>
    </RaContainer>
  )
})

AcfTrustpilotIntro.displayName = 'AcfTrustpilotIntro'
